import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=24445a22&scoped=true&"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePasswordPage.vue?vue&type=style&index=0&id=24445a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24445a22",
  null
  
)

export default component.exports